<cx-icon class="icon" [type]="iconType.ARROW_SLIDE"></cx-icon>
